import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import singleSpaReact from 'single-spa-react';
import singleSpaCss from 'single-spa-css';
import { AppName } from '@home-diy-toolbox/web/common-types/refresh-base';
import { Providers } from './providers/Providers';
import { ErrorPage } from './pages';
import { monitor } from '@soluto-private/mx-monitor';
import { GlobalStyle } from '@home-diy-toolbox/web/theme';
import { environment } from './environments/environment';

const SingleSpaRootApp = () => {
	useEffect(() => {
		// production environmment is not yet ready for device care osp v2.
		if (environment.production) return;

		const url = new URL(window.location.href);
		// Added to prevent redirecting to v2 when the url has redirectToV2=false
		const redirectToV2 = url.searchParams.get('redirectToV2');

		if (!redirectToV2 || redirectToV2 !== 'false') {
			window.location.replace(`${environment.deviceCareV2Url}${url.search}`);
		}
	}, []);

	return (
		<React.StrictMode>
			<GlobalStyle />
			<BrowserRouter basename={AppName}>
				<Providers />
			</BrowserRouter>
		</React.StrictMode>
	);
};

const cssLifecycles = singleSpaCss({
	cssUrls: [],
	webpackExtractedCss: true,
});

const reactLifecycles = singleSpaReact({
	React,
	ReactDOM,
	rootComponent: SingleSpaRootApp,
	errorBoundary: (error, _info, _props) => {
		monitor.error(error.message, error);
		return <ErrorPage />;
	},
});

export const bootstrap = [cssLifecycles.bootstrap, reactLifecycles.bootstrap];

export const mount = [cssLifecycles.mount, reactLifecycles.mount];

export const unmount = [reactLifecycles.unmount, cssLifecycles.unmount];
